import { getWithParamsRequest, postRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

export interface RecordingService {
  code: string;
  name: string;
}

export interface Recording {
  tripId: number;
  tripSlug: string;
  deviceRecordingId: number;
  startedAt: string;
  riderNames: string[];
  pickupLocationName: string;
  dropoffLocationName: string;
  stops: number;
  tags: string[];
  driverName: string;
  services: RecordingService[];
  recordingStatus: 'available' | 'unavailable';
}

export type DownloadReason = 'routine_review' | 'potential_incident_review' | 'other';

export interface RecordingsParams {
  riderName?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  perPage?: number;
}

export interface RecordingDownloadPayload {
  reason: DownloadReason;
  reasonDetail?: string;
}

export interface RecordingDownloadResponse {
  downloadUrl: string;
  expiresAt: string;
}

export async function getRecordings(
  params: RecordingsParams,
  signal?: AbortSignal
): Promise<ApiResponse<{ deviceRecordings: Recording[] }>> {
  return getWithParamsRequest('device_recordings', params, signal);
}

export async function requestRecordingDownload(
  deviceRecordingId: number,
  payload: RecordingDownloadPayload
): Promise<ApiResponse<RecordingDownloadResponse>> {
  return postRequest(`device_recordings/${deviceRecordingId}/download`, payload);
}
